import { FunctionComponent } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";

const NotFound: FunctionComponent = () => {
  return (
    <Container>
      <Row>
        <Col>
          <h1>Not Found</h1>
          <p>The page you were looking for does not exist</p>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
